import { useTranslation } from 'react-i18next';
import { ModulePlaceholderForm } from '../../components/ModulePlaceholderForm';

export default function NewRecruitment() {
  const { t } = useTranslation('panel');
  return (
    <ModulePlaceholderForm
      title="New job requisition"
      listPath="/panel/recruitments"
      tabs={[
        {
          key: 'basic',
          label: t('form.tabs.basic'),
          fields: [
            { key: 'jobTitle', label: 'Job title', required: true, placeholder: 'Senior React Developer' },
            { key: 'department', label: 'Department', placeholder: 'Engineering' },
            {
              key: 'employmentType',
              label: 'Employment type',
              type: 'select',
              options: [
                { value: 'full-time', label: 'Full-time' },
                { value: 'part-time', label: 'Part-time' },
                { value: 'contract', label: 'Contract' },
                { value: 'intern', label: 'Intern' },
              ],
            },
            { key: 'openings', label: 'Open positions', type: 'number', placeholder: '1' },
          ],
        },
        {
          key: 'details',
          label: t('form.tabs.details'),
          fields: [
            { key: 'minExp', label: 'Min. experience (years)', type: 'number' },
            { key: 'maxSalary', label: 'Max. CTC (₹/yr)', type: 'number' },
            { key: 'location', label: 'Work location', placeholder: 'Bangalore' },
            { key: 'description', label: 'Job description', type: 'textarea' },
          ],
        },
        {
          key: 'documents',
          label: t('form.tabs.documents'),
          fields: [
            { key: 'closingDate', label: 'Application close date', type: 'date' },
            { key: 'hiringManager', label: 'Hiring manager email', type: 'email' },
            { key: 'notes', label: 'Internal notes', type: 'textarea' },
          ],
        },
        { key: 'review', label: t('form.tabs.review'), fields: [] },
      ]}
    />
  );
}
